<template>
  <div
    class="page--company-financial-config"
    :style="`min-height: ${height}px`"
  >
    <Header :status="currentStatus" />

    <section v-if="false" class="form-fw__content">
      <FormBox>
        <div class="text-xs-center">
          Funcionalidade indisponível no momento. Por favor, tente novamente mais tarde.
        </div>
      </FormBox>
    </section>

    <div v-else>
      <Form
        v-if="hasRole('profiles', 'ROLE_ADMINISTRATOR') || hasRole('profiles', 'ROLE_FINANCIAL_ADMIN')"
        :submit="submitForm"
        :data="companyData"
        :status="currentStatus"
        @tryAgain="getWalletFinancialConfig"
        @setCurrentStatus="setCurrentStatus"
      />

      <BasicForm
        v-if="hasRole('profiles', 'ROLE_CORPORATE_USER')"
        :submit="submitForm"
        :data="companyData"
        :status="currentStatus"
        @tryAgain="getWalletFinancialConfig"
        @setCurrentStatus="setCurrentStatus"
      />

      <Footer
        :status="currentStatus"
        @submit="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { mapState, mapActions } from 'vuex'
import { isArray, hasRole } from 'utils/functions'
import Header from 'components/companyFinancialConfig/Header'
import Form from 'components/companyFinancialConfig/Form'
import BasicForm from 'components/companyFinancialConfig/BasicForm'
import Footer from 'components/companyFinancialConfig/Footer'
import FormBox from 'components/FormBox'

export default {
  name: 'CostCenterPage',
  components: {
    Header,
    Form,
    BasicForm,
    Footer,
    FormBox
  },
  computed: {
    ...mapState({
      globalCompany: ({ company }) => company.selectedCompany
    }),

    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyFinancialConfigPage',
      submitForm: false,
      companyData: {},
      currentStatus: null
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    isvalidArray: (val) => isArray(val),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    async getWalletFinancialConfig () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const companyId = this.$route.params.id || this.globalCompany.id
        const { data: res } = await this.$apiService.getWalletFinancialConfig(companyId)

        if (!res || !res.valid) {
          throw new Error(res.reasons[0])
        }

        if (res.content) {
          const {
            financialAccountId,
            periodicityConfigType,
            paymentMethod,
            dueDays,
            emailsToNotify,
            isSaasActive,
            serviceStartChargeDate = null,
            serviceMonthlyFee,
            serviceTaxiJobFee
          } = res.content

          this.companyData = {
            financialAccountId,
            periodicityConfigType,
            paymentMethod,
            dueDays,
            emailsToNotify: emailsToNotify.map(email => email.trim()),
            isSaasActive,
            serviceStartChargeDate,
            serviceMonthlyFee,
            serviceTaxiJobFee
          }
        }

        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR', err)
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  watch: {
    'routeParams.id' () {
      location.reload()
    }
  },
  mounted () {
    this.setChatPosition('75px', '10px')
    this.getWalletFinancialConfig()
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
